module.exports = __webpack_public_path__ + "static/img/home_banner3.458235b1.png";